import { FunctionComponent } from 'preact';
import { useStyles } from '../../hooks/useStyles';
import { getTooltipStyleObject } from './toolTip.styles';
import { TOOLTIP_POSITIONS, ToolTipType } from './toolTip.contants';
import { useHoverRef } from '../../hooks/useHoverRef';
import { css } from '../../styles/styles.utils';

export interface Variables {
  marginRight?: string;
  marginLeft?: string;
  marginBottom?: string;
}

interface ToolTipProps {
  content: string;
  position: ToolTipType;
  variables?: Variables;
  id?: string;
}

export const ToolTip: FunctionComponent<ToolTipProps> = props => {
  const {
    content = 'Tooltip',
    position = TOOLTIP_POSITIONS.BOTTOM,
    children,
    variables,
    id,
  } = props;

  const [refObject, hovered] = useHoverRef();
  const styles = useStyles(getTooltipStyleObject, [hovered, position, variables]);
  const { tooltipStyle, tooltipContentStyle } = styles;

  return (
    <div
      data-tooltip-text={content}
      style={css(tooltipStyle)}
      ref={refObject}
    >
      <div style={css(tooltipContentStyle)} id={id}>{content}</div>
      {children}
    </div>
  );
};
